import {
  getDocumentaryDocumentsSearch,
  getGetDocumentaryDocumentsSearchQueryKey
} from 'client/api/backend/documentary-documents/documentary-documents';
import { GetDocumentaryDocumentsSearchParams } from 'client/api/backend/schemas';
import { ErrorType } from 'client/core/network/mutators/apiClient';
import {
  QueryFunction,
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AsyncReturnType<T extends (...args: any) => Promise<any>> = T extends (
  ...args: any
) => Promise<infer R>
  ? R
  : any;

export const InfiniteDocumentsSearchPageStart = 0;

export const useInfiniteDocumentsSearch = <
  TData = AsyncReturnType<typeof getDocumentaryDocumentsSearch>,
  TError = ErrorType<void>
>(
  params?: GetDocumentaryDocumentsSearchParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      AsyncReturnType<typeof getDocumentaryDocumentsSearch>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options || {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDocumentaryDocumentsSearchQueryKey(params);

  const queryFn: QueryFunction<
    AsyncReturnType<typeof getDocumentaryDocumentsSearch>
  > = ctx =>
    getDocumentaryDocumentsSearch({
      ...params!,
      pageNumber: ctx.pageParam ?? InfiniteDocumentsSearchPageStart
    });

  const query = useInfiniteQuery<
    AsyncReturnType<typeof getDocumentaryDocumentsSearch>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions);

  return {
    queryKey,
    ...query
  };
};
